module.exports = __webpack_public_path__ + "static/media/c-mexican.a6ce2586.png";